<template lang="pug">
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0711 5.42893L3 12.5L10.0711 19.5711" stroke="#141414" stroke-width="2" stroke-linejoin="round"/>
        <path d="M3 12.5L22 12.5" stroke="#141414" stroke-width="2" stroke-linejoin="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.41421 13.4999L10.7782 18.8638L9.36396 20.278L2.29289 13.207C1.90237 12.8164 1.90237 12.1833 2.29289 11.7927L9.36396 4.72168L10.7782 6.13589L5.41421 11.4999L22 11.4999V13.4999L5.41421 13.4999Z" fill="#141414"/>
    </svg>
</template>

<style lang="stylus" scoped>

</style>

<script>
export default {
    methods:{
        emitClick(event){
            this.$emit('click', event)
        }
    }
}
</script>
